/** Mention légale affichée en bas de page. */
export default function Copyright({ dark = false }) {
  return (
    <div data-testid="copyright"
      className={`px-6 py-4 text-center text-xs ${dark ? "text-white/40" : "text-muted-foreground"}`}>
      © {new Date().getFullYear()} Innova-Solution inc. — Tous droits réservés. Innova Route et son contenu
      sont la propriété exclusive d'Innova-Solution inc.
    </div>
  );
}
